import Vue from 'vue'
import Vuex from 'vuex'
import {
  User,
  Recipe,
  Collection } from '@/modules'
import {
  ADD_SEARCH,
  ADD_NOTIFICATION,
  POP_NOTIFICATION,
  SET_HISTORY,
  REMOVE_VIEW_DETAIL,
  CLEAR_VIEW,
  SET_VIEW,
  SHOW_PRIMARY_VIEW,
  HIDE_PRIMARY_VIEW,
  SET_WINDOW_SIZE,
  SET_OBFUSCATOR_VISIBILITY,
  SET_DRAWER_VISIBILITY,
  SET_TEMPORARY_VIEW_VISIBILITY,
  SET_COLLECTION_VIEW_STYLE,
  TOGGLE_FULLSCREEN,
  REGISTER_SHORTCUT,
  DEREGISTER_SHORTCUT } from '@/modules/mutation-types'
import {
  getWindowSizeName,
  getBrowserMode,
  getBrowserDetails,
  getScreenOrientation } from '@/utils'
import {
  hasNativeWakeLock
} from '@/utils/wakelock'

Vue.use(Vuex)
/* eslint-disable no-new */
const store = new Vuex.Store({
  state: {
    device: {
      browser: getBrowserDetails(),
      hasNativeWakeLock: hasNativeWakeLock(),
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
      mode: getBrowserMode(),
      orientation: getScreenOrientation(),
      pixelRatio: Math.round(window.devicePixelRatio),
      sizeClass: window.innerWidth < 750 ? 'compact' : 'regular',
      sizeName: getWindowSizeName()
    },
    app: {
      collectionStyle: 'list',
      obfuscator: {
        visibility: 'hidden'
      },
      drawer: {
        visibility: 'hidden'
      },
      history: null,
      notifications: [],
      projectId: 'collections-8c06c.appspot.com',
      recentSearches: [],
      shortcuts: {},
      // collection-next-item: { keycode: 38, modifiers: [], fn: () => {} }
      view: {
        primaryHidden: false
      },
      views: {
        recipe: {
          // displayMode: SIDE_BY_SIDE // HIDDEN
          fullscreen: false,
          key: null,
          primaryHidden: false
        },
        search: {
          fullscreen: false,
          key: null,
          primaryHidden: false
        }
      },
      temporaryView: null
    }
  },
  getters: {
    isDetailFullScreen: state => state.app.view.fullscreen,
    isSizeClassCompact: state => state.device.sizeClass === 'compact',
    isSizeClassRegular: state => state.device.sizeClass === 'regular',
    temporaryViewProps: state => (state.app.temporaryView && state.app.temporaryView.props) || {}
  },
  modules: {
    User,
    Recipe,
    Collection
  },
  mutations: {
    [ADD_NOTIFICATION] (state, payload) {
      state.app.notifications.push(payload)
    },
    [POP_NOTIFICATION] (state) {
      state.app.notifications.pop()
    },
    [SET_HISTORY] (state, payload) {
      state.app.history = payload.path
    },
    [REMOVE_VIEW_DETAIL] (state, payload) {
      Vue.delete(state.app.views[payload.view], 'key')
    },
    // [SET_VIEW] (state, payload) {
    //   Vue.set(state.app, 'view', Object.assign({},
    //     state.app.view,
    //     { primaryHidden: true },
    //     payload
    //   ))
    // },
    [CLEAR_VIEW] (state, payload) {
      Vue.set(state.app.views, payload.view, {
        fullscreen: false,
        key: null
      })
    },
    [SET_VIEW] (state, payload) {
      let view = payload.view
      delete payload.view
      Vue.set(state.app.views, view, Object.assign({},
        state.app.views[view],
        payload
      ))
    },
    [HIDE_PRIMARY_VIEW] (state, payload) {
      state.app.views[payload.view].primaryHidden = true
    },
    [SHOW_PRIMARY_VIEW] (state, payload) {
      state.app.views[payload.view].primaryHidden = false
    },
    [SET_WINDOW_SIZE] (state, payload) {
      state.device.innerWidth = payload.width
      state.device.innerHeight = payload.height
      state.device.sizeClass = payload.width < 750 ? 'compact' : 'regular'
      state.device.sizeName = getWindowSizeName(payload.width)
    },
    [SET_OBFUSCATOR_VISIBILITY] (state, payload) {
      state.app.obfuscator.visibility = payload.visibility
    },
    [SET_DRAWER_VISIBILITY] (state, payload) {
      state.app.drawer.visibility = payload.visibility
    },
    [SET_TEMPORARY_VIEW_VISIBILITY] (state, payload) {
      Vue.set(state.app, 'temporaryView', payload)
    },
    [SET_COLLECTION_VIEW_STYLE] (state, payload) {
      state.app.collectionStyle = payload.style
    },
    [TOGGLE_FULLSCREEN] (state) {
      Vue.set(state.app.view, 'fullscreen', !state.app.view.fullscreen)
    },
    [REGISTER_SHORTCUT] (state, payload) {
      state.app.shortcuts = {
        ...state.app.shortcuts,
        ...{ [payload.name]: payload }
      }
    },
    [DEREGISTER_SHORTCUT] (state, name) {
      Vue.delete(state.app.shortcuts, name)
    },
    [ADD_SEARCH] (state, payload) {
      let arr = state.app.recentSearches
      // if we're updating then we'll remove the old entry
      if (arr.indexOf(payload.oldQuery) >= 0) {
        arr.splice(arr.indexOf(payload.oldQuery), 1)
      }
      // if we're adding a new one then remove any matching prior entries
      if (arr.indexOf(payload.query) >= 0) {
        arr.splice(arr.indexOf(payload.query), 1)
      }
      arr.unshift(payload.query)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js